export const TIPO_ACESSO = {
  INTERNO: 1,
  EXTERNO: 2,
};
